// src/screens/VoucherScreen.js
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { clearQRData } from "../services/localStorageService";

const VoucherScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const voucher = location.state?.voucher;

  const handleDone = () => {
    clearQRData();
    navigate("/");
  };

  if (!voucher) {
    return (
      <div className="screen-container">
        <div className="thank-you-container">
          <div className="thank-you-icon">!</div>
          <h1 className="thank-you-title">No Voucher Found</h1>
          <p className="thank-you-message">
            Your voucher details were not found. Please check your email for
            your voucher code.
          </p>
          <button className="button" onClick={handleDone}>
            Done
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="screen-container">
      <div className="thank-you-container">
        <div className="thank-you-icon" style={{ fontSize: "2rem" }}>
          🎉
        </div>
        <h1 className="thank-you-title">Your Voucher!</h1>
        <p className="thank-you-message">
          Thank you for your feedback! Here is your exclusive voucher.
        </p>

        <div
          style={{
            background: "#f8f9fa",
            border: "2px dashed #ddd",
            borderRadius: "12px",
            padding: "20px",
            textAlign: "center",
            margin: "20px 0",
          }}
        >
          <div
            style={{
              fontSize: "0.75rem",
              textTransform: "uppercase",
              color: "#888",
              letterSpacing: "1px",
              marginBottom: "8px",
            }}
          >
            Your Voucher Code
          </div>
          <div
            style={{
              fontSize: "1.6rem",
              fontWeight: "700",
              fontFamily: "monospace",
              color: "#333",
              letterSpacing: "3px",
            }}
          >
            {voucher.code}
          </div>
        </div>

        {voucher.url && (
          <a
            href={voucher.url}
            target="_blank"
            rel="noopener noreferrer"
            className="button"
            style={{
              display: "block",
              textDecoration: "none",
              textAlign: "center",
              marginBottom: "12px",
            }}
          >
            Redeem Voucher
          </a>
        )}

        <p
          style={{
            fontSize: "0.85rem",
            color: "#888",
            textAlign: "center",
          }}
        >
          A copy has also been sent to your email.
        </p>

        <button
          className="button"
          onClick={handleDone}
          style={{
            maxWidth: "200px",
            margin: "16px auto 0",
            background: "#666",
          }}
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default VoucherScreen;
